import { Instance, types } from 'mobx-state-tree';

import { getParent, saveParent } from '@common/api/parents';
import CgClass from '@common/models/CgClasses/CgClass';
import CgSchool from '@common/models/CgSchools/CgSchool';
import CgCoordinator from '@common/models/Users/CgCoordinators/CgCoordinator';
import Student from '@common/models/Users/Students/Student';
import User from '@common/models/Users/User';

import CgStudent from '../CgStudents/CgStudent';

// @ts-ignore
const Parent = types
	.compose(
		User,
		types.model({
			cg_login_token: types.maybeNull(types.string),
			cg_schools_ids: types.optional(types.array(types.number), []),
			cg_schools: types.optional(types.array(CgSchool), []),
			cg_coordinators_ids: types.optional(types.array(types.number), []),
			cg_coordinators: types.optional(types.array(CgCoordinator), []),
			cg_classes_ids: types.optional(types.array(types.number), []),
			cg_classes: types.optional(types.array(CgClass), []),
			cg_students_ids: types.optional(types.array(types.number), []),
			// @ts-ignore
			cg_students: types.optional(types.array(types.late(() => CgStudent)), []),
			phone: types.maybeNull(types.string),
			link_to_deal: types.maybeNull(types.string),
			comment: types.optional(types.string, ''),
			// @ts-ignore
			students: types.optional(types.array(types.late(() => Student)), []),
			avatar_url: types.maybeNull(types.string),
		}),
	)
	.named('Parent')
	.preProcessSnapshot((snapshot: any) => ({
		...snapshot,
		cg_schools_ids: snapshot?.cg_schools_ids || [],
		cg_schools: snapshot?.cg_schools || [],
		cg_coordinators_ids: snapshot?.cg_coordinators_ids || [],
		cg_coordinators: snapshot?.cg_coordinators || [],
		cg_classes_ids: snapshot?.cg_classes_ids || [],
		cg_classes: snapshot?.cg_classes || [],
		cg_students_ids: snapshot?.cg_students_ids || [],
		cg_students: snapshot?.cg_students || [],
	}))
	.actions(() => ({
		_fetch: getParent,
		_save: saveParent,
	}));

// @ts-ignore
export default Parent;

export interface IParentModel extends Instance<typeof Parent> {}
